 <div class="table-wrapper" *ngIf="userInfo?.ActiveInvestments?.length && activeInvestmentsConfig">
   <div class="table-row sub-title-background">
     <ng-container *ngFor="let column of activeInvestmentsConfig.columns; let first = first">
       <div class="text-color-deep-heading col-1-header" [class.text-right]="!first">
         {{column.title}}:
         <span *ngIf="column.titleValueField"><span class="text-color-black">
             <FormatLabel *ngIf="column.titleValuePattern" [Text]="userInfo[column.titleValueField]"
                          class="FieldContent ml-16"
                          [FormatPattern]="column.titleValuePattern"
                          [class.red]="userInfo[column.titleValueField] < 0"></FormatLabel>
             <span *ngIf="!column.titleValuePattern">{{userInfo[column.titleValueField]}}</span>
           </span>
         </span>
       </div>
     </ng-container>

   </div>
 </div>

 <div class="scrolled" *ngIf="userInfo?.ActiveInvestments?.length && activeInvestmentsConfig">
   <div *ngFor="let i of userInfo.ActiveInvestments" class="text-color-black table-row">
     <ng-container *ngFor="let column of activeInvestmentsConfig.columns; let first = first">
       <div class="text-color-black font-600" [class.text-right]="!first"
            *ngIf="column.formatPattern && !column.dateFormat && !column.applyMask"> <span
         class="cell">
                                           <FormatLabel [Text]="i[column.field]"
                                                        [class.red]="i[column.field] < 0"
                                                        class="FieldContent"
                                                        [FormatPattern]="column.formatPattern"></FormatLabel>
                                       </span>
       </div>

       <div class="text-color-black font-600" [class.text-right]="!first"
            *ngIf="!column.formatPattern && !column.applyMask && column.dateFormat"> <span
         class="cell">
           <span class="FieldContent">{{i[column.field] | date : column.dateFormat}}</span>
                                       </span>
       </div>

       <div class="text-color-black" [class.text-right]="!first"
            *ngIf="!column.formatPattern  && !column.applyMask && !column.dateFormat"> <span>
                                          {{ i[column.field]}}
                                       </span>
       </div>

       <div class="text-color-black" [class.text-right]="!first"
            *ngIf="!column.formatPattern  && column.applyMask && !column.dateFormat">
         <app-secure-mask [value]="i[column.field]"></app-secure-mask>
       </div>
     </ng-container>
   </div>
 </div>
 <!--                      inActive     -->
 <div class="table-wrapper" *ngIf="userInfo?.InActiveInvestments?.length && inactiveInvestmentsConfig">
   <div class="table-row sub-title-background">
     <ng-container *ngFor="let column of inactiveInvestmentsConfig.columns; let first = first">
       <div class="text-color-deep-heading col-1-header" [class.text-right]="!first">
         {{column.title}}:
         <span *ngIf="column.titleValueField"><span class="text-color-black">
             <FormatLabel *ngIf="column.titleValuePattern" [Text]="userInfo[column.titleValueField]"
                          class="FieldContent ml-16"
                          [class.red]="userInfo[column.titleValueField] < 0"
                          [FormatPattern]="column.titleValuePattern"></FormatLabel>
             <span *ngIf="!column.titleValuePattern">{{userInfo[column.titleValueField]}}</span>
           </span>
         </span>
       </div>
     </ng-container>

   </div>
 </div>

 <div class="scrolled" *ngIf="userInfo?.InActiveInvestments?.length && inactiveInvestmentsConfig">
   <div *ngFor="let i of userInfo.InActiveInvestments" class="text-color-black table-row">
     <ng-container *ngFor="let column of inactiveInvestmentsConfig.columns; let first = first">
       <div class="text-color-black font-600" [class.text-right]="!first"
            *ngIf="column.formatPattern && !column.dateFormat && !column.applyMask"> <span
         class="cell">
                                           <FormatLabel [Text]="i[column.field]"
                                                        [class.red]="i[column.field] < 0"
                                                        class="FieldContent"
                                                        [FormatPattern]="column.formatPattern"></FormatLabel>
                                       </span>
       </div>

       <div class="text-color-black font-600" [class.text-right]="!first"
            *ngIf="!column.formatPattern && !column.applyMask && column.dateFormat"> <span
         class="cell">
           <span class="FieldContent">{{i[column.field] | date : column.dateFormat}}</span>
                                       </span>
       </div>

       <div class="text-color-black" [class.text-right]="!first"
            *ngIf="!column.formatPattern  && !column.applyMask && !column.dateFormat"> <span>
                                          {{ i[column.field]}}
                                       </span>
       </div>

       <div class="text-color-black" [class.text-right]="!first"
            *ngIf="!column.formatPattern  && column.applyMask && !column.dateFormat">
         <app-secure-mask [value]="i[column.field]"></app-secure-mask>
       </div>
     </ng-container>
   </div>
 </div>


 <div class="col-lg-12 border-class divider-color"
      *ngIf="userInfo?.InActiveInvestments?.length && inactiveInvestmentsConfig">
                         <span class="float-right">
                             <a [routerLink]="['/investment']">...{{'MORE' | dictionary}}</a>
                         </span>
 </div>
